<!--
 * @Author: wangjx
 * @LastEditors: wangjx
 * @Date: 2021-12-01 16:26:03
 * @LastEditTime: 2021-12-06 15:52:36
 * @Description: file content
-->
<template>
  <div class="form_footer">
    <span>
      Copyright © 2021 IROOTECH. All rights reserved. 树根互联 版权所有 粤ICP备19026860号-1
    </span>
  </div>
</template>

<script>
export default {
  name: "LogoFooter",
  props: {},
  methods: {}
};
</script>

<style lang="scss" scoped>
@import "../../../assets/fonts/sourcehansans.css";
.form_footer {
  position: fixed;
  width: 100%;
  text-align: center;
  bottom: 0;
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  font-weight: 400;
  color: #868790;
  background: #f5f7fa;
}
</style>
